import { render, staticRenderFns } from "./dp.vue?vue&type=template&id=4fd0bd40&"
import script from "./dp.vue?vue&type=script&lang=js&"
export * from "./dp.vue?vue&type=script&lang=js&"
import style0 from "./dp.vue?vue&type=style&index=0&id=4fd0bd40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports